import alt from '../alt';
import { getElements } from '../config/elements';
import FlowActions from '../actions/flow';
import GraphActions from '../actions/graph';

class FlowStore {

    constructor() {

        this.bindListeners({
            getActivated: FlowActions.onGetActivated,
            open: FlowActions.open,
            update: [GraphActions.onGet, GraphActions.onSave, FlowActions.update],
            close: FlowActions.close,
            openSubflow: FlowActions.openSubflow,
            openConfig: FlowActions.openConfig,
            closeConfig: FlowActions.closeConfig,
            onChange: FlowActions.onChange,
            setActions: FlowActions.setActions,
        });

        this.elements = getElements();
        this.actions = [];
        this.flows = {};
        this.activatedFlows = [];
        this.flowsLoading = true;
    }

    setActions(actions) {
        this.actions = actions;
    }

    getActivated(flows) {
        this.activatedFlows = flows;
        this.flowsLoading = false;
    }

    open(flowId) {
        this.flows[flowId] = {
            id: flowId,
        };
    }

    openSubflow(flowId) {
        this.flows[flowId] = {
            id: flowId,
        };
    }

    update({ response: flow }) {
        this.flows[flow.id.id] = {
            id: flow.id.id,
            versionId: flow.id.versionId,
            isLocked: this.flows[flow.id.id].isLocked,
            config: this.flows[flow.id.id].config,
        };
    }

    close(id) {

    }

    openConfig(config) {
        this.flows[config.flowId].config = config;
        this.flows[config.flowId].isLocked = true;
    }

    closeConfig(flowId) {
        this.flows[flowId].config = null;
        this.flows[flowId].isLocked = false;
    }

    onChange(change) {
        if (!this.flows[change.id].isLocked)
            setTimeout(() => GraphActions.get(change.id, change.tenantId, change.authenticationToken));
    }

}

export default alt.createStore(FlowStore, 'flow');
